module.exports = __webpack_public_path__ + "static/media/logo-text.064e8772.png";